import React, { useCallback, useEffect, useRef, useState } from "react";
import { FILTER_OP_MAP, FILTER_VALUES, PAY_TYPE } from "./constant";
import { DATE_TIME_FORMATS } from "../../../../data/constants";
import moment from "moment";
import { cloneDeep } from "lodash";
import useInfiniteScroll from "../../../../hooks/useInfiniteScroll";
import { isMobileTabDevice } from "../../../../helpers/device-info-helper";

type FranchisePros = {
  reportData: any[];
  getFranchiseReportData: () => void;
  setPayType: (val : string) => void;
  setInvoiceType: (val : string) => void
};

export const FranchiseReport = (props: FranchisePros) => {
  const { reportData = [], getFranchiseReportData, setPayType, setInvoiceType} = props;
  const [franchiseReport, setFranchiseReport] = useState(reportData);
  const [selectedFilter, setSelectedFilter] = useState<string[]>([]);
  const [reportUrl, setReportUrl] = useState("");
  const [isReportClick, setReportClick] = useState(false);
  const [gridViewRef, setGridViewRef] = useState<any>({ current: null });
  const { isAtBottom } = useInfiniteScroll(gridViewRef);

  useEffect(() => {
    setFranchiseReport(reportData);
    if(!isAtBottom)
    {
      setReportUrl('');
    }
  }, [reportData]);

  useEffect(() => {
    if (isAtBottom) {
      getFranchiseReportData?.();
    }
  }, [isAtBottom]);

  function handleFilterSelect(filterKey: string) {
    const filterList = [...selectedFilter];
    if (!selectedFilter?.includes(filterKey)) {
      if (PAY_TYPE?.includes(filterKey)) {
        setPayType(filterKey);
      } else {
        setInvoiceType(filterKey);
      }
      const anotherKey = FILTER_OP_MAP[filterKey];
      const index = filterList?.indexOf(anotherKey);
      if (index >= 0) filterList?.splice(index, 1);
      setSelectedFilter([...filterList, filterKey]);
    } else {
      if (PAY_TYPE?.includes(filterKey)) {
        setPayType("");
      } else {
        setInvoiceType("");
      }
      const index = filterList?.indexOf(filterKey);
      filterList?.splice(index, 1);
      setSelectedFilter(filterList);
    }
  }

  function handleReportClick(data: any) {
    setReportUrl(data?.invoiceLink);
    setReportClick((prev) => !prev);
  }

  const callbackRef = useCallback((tempRef: any) => {
    if (!tempRef) return;
    setGridViewRef({ current: tempRef });
  }, []);

  const renderEmptyState = () => {
    return (
      <div className="empty-state m-auto mt-[30%] flex flex-col items-center">
        <div className="rista-sprite ic-empty-box"></div>
        <div className="headings flex flex-col items-center">
          <span className="font-[18px] opacity-[.7] font-[600]">
            {"Its all empty in here!"}
          </span>
          <span className="text-[14px] text-[#6C6C6C] sm:text-center">
            {"Please select date range and branches to see franchise invoices"}
          </span>
        </div>
      </div>
    );
  };

  const renderFilter = () => {
    return (
      <div className="bg-[#FFFFFF] w-[100%] px-[16px] py-[12px] sm:relative">
        <div className="flex items-center gap-[16px] overflow-auto">
          {FILTER_VALUES?.map((val: Record<string, string>) => {
            const isSelected = selectedFilter?.includes(val.key);
            return (
              <div
                onClick={() => handleFilterSelect(val?.key)}
                key={val.key}
                className={`${
                  isSelected ? "bg-[#347BFA1A]" : "bg-[#FFFFFF0D]"
                } border border-[#0000001A] rounded-[8px] cursor-pointer p-[10px] flex items-center justify-center gap-[10px]`}
              >
                <div className="sm:w-[80px]">{val.label}</div>
                {isSelected && (
                  <div className="rista-sprite ic-cross-grey-sm "></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderLeftSection = () => {
    return (
      <>
        <div className="w-[100%]">{renderFilter()}</div>
        <div
          style={{ maxHeight: window.innerHeight - 250 }}
          className="invoice-details mt-[5px] bg-[#fff] overflow-scroll border-r border-[#0000000D]"
          ref={callbackRef}
        >
          {franchiseReport?.map((data: any, index: number) => {
            const isPaid = data?.balanceAmount === 0;
            return (
              <div
                onClick={() => handleReportClick(data)}
                key={index}
                className="w-[100%] cursor-pointer flex items-center justify-between p-[12px] sm:p-[12px] border-b border-[#0000000D]"
              >
                <div className="flex flex-col">
                  <div className="flex sm:flex-col items-center sm:items-start gap-[10px] sm:gap-y-[1px]">
                    <span className="text-[14px] font-[600]">
                      {data?.branchName || ""}
                    </span>
                    {!isMobileTabDevice() && (
                      <div className="border border-[#0000000D] h-[20px] w-[1px]"></div>
                    )}
                    <span className="text-[12px] text-[#0000007A] fonnt-[500]">
                      {data?.invoiceType}
                    </span>
                  </div>
                  <div className="text-[14px] opacity-[.7] mt-[10px]">
                    {`${moment(data.startDate).format(
                      DATE_TIME_FORMATS.monthDayYear
                    )} - ${moment(data.endDate).format(
                      DATE_TIME_FORMATS.monthDayYear
                    )}`}
                  </div>
                </div>
                <div className="flex flex-col">
                  <div
                    className={`flex items-center justify-end gap-[16px] ${
                      isPaid ? "text-[#37812B]" : "text-[#A55858]"
                    }`}
                  >
                    <div
                      className={`text-[10px] font-[600] rounded-[4px] ${
                        isPaid ? "bg-[#EBF2EA]" : "bg-[#A558581A]"
                      } p-[4px]`}
                    >
                      {isPaid ? "PAID" : "UNPAID"}
                    </div>
                    <div className="text-[14px] font-[600] w-[70px] text-right">
                      {"₹" + data?.invoiceAmount}
                    </div>
                  </div>
                  <div className="text-[13px] text-[#0000007A] mt-[10px] sm:w-[100px] text-right">
                    {"Invoice Date: " +
                      moment(data?.saleDate).format(
                        DATE_TIME_FORMATS.monthDayYear
                      )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  const renderRightSection = () => {
    return (
      <div
        style={{ minHeight: window.innerHeight - 175 }}
        className="bg-[#fff]"
      >
        {isMobileTabDevice() && (
          <div
            onClick={() => setReportClick((prev) => !prev)}
            className="rista-sprite ic-arrow-grey-back mb-[5px]"
          ></div>
        )}
        {reportUrl && (
          <iframe
            id="ristaIframe"
            title="FranchiseReport"
            width="100%"
            height={window.innerHeight - 175}
            src={reportUrl}
          ></iframe>
        )}
      </div>
    );
  };

  const renderInvoice = () => {
    const shouldShowReport = isMobileTabDevice() ? isReportClick : true;
    const shouldShowReportList = isMobileTabDevice() ? !isReportClick : true;
    return (
      <div className="flex sm:flex-col sm:gap-y-[20px]">
        {shouldShowReportList && (
          <div className="w-[50%] sm:w-[100%] border-r border-[#0000000D]">
            {renderLeftSection()}
          </div>
        )}
        {shouldShowReport && (
          <div className="w-[50%] sm:w-[100%]">{renderRightSection()}</div>
        )}
      </div>
    );
  };
  const shouldRender = reportData?.length ? true : (selectedFilter?.length ? true : false)
  return (
    <div className={`w-[100%] p-[12px] ${isReportClick ? "sm:bg-white" : ""} `}>
      { shouldRender ? <div>{renderInvoice()}</div> : renderEmptyState()}
    </div>
  );
};
